<template>
  <div class="p-ai">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <SlickCarousel className="ai" :baseData="baseData.list" :textLeft="true" />
    <!-- <ul>
    <li v-for="(item, index) in baseData.list" 
      :index="index" 
      :key="index">
      <p>{{item.title}}</p>
      <p>{{item.desc}}</p>
      <p>
        <img :src="item.bigImg" />
      </p>
    </li>
  </ul> -->
    <div class="p-block-more">
      <kd-link
        type="primary"
        @click="
          $emit('homeCallback', {
            dwClickName: 'learn_more_smart_plat',
          })
        "
      >
        <KdIcon
          icon="ArrowRightS"
          :size="24"
          fill="currentColor"
          margin="0 0 0 3px"
          leftText="点击咨询，了解更多"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import KdIcon from '@/components/KdIcon/index.vue';
import { aiData } from '@/views/homeV2/config.js';
import SlickCarousel from '@/components/SlickCarousel/index.vue';
export default {
  name: 'ai-component',
  components: { KdIcon, SlickCarousel },
  data() {
    return {
      baseData: aiData,
    };
  },
};
</script>

<style lang="scss" scoped>
.p-ai {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;

  ul {
    margin: 40px auto 0 auto;
    li {
      display: inline-block;
      width: 282px;
      height: 356px;
      margin-right: 24px;
      margin-bottom: 24px;
      padding: 32px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.08);
      box-shadow: 0px 4px 20px 0px rgba(13, 13, 13, 0.03);
      border-radius: 12px;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 101% !important;

      &:nth-child(1) {
        background: linear-gradient(
          360deg,
          rgba(255, 255, 255, 0.5) 44.59%,
          rgba(87, 187, 254, 0.5) 100%
        );
      }
      &:nth-child(2) {
        background: linear-gradient(
          360deg,
          rgba(255, 255, 255, 0.5) 44.59%,
          rgba(87, 254, 140, 0.5) 100%
        );
      }
      &:nth-child(3) {
        background: linear-gradient(
          360deg,
          rgba(255, 255, 255, 0.5) 44.59%,
          rgba(134, 87, 254, 0.5) 100%
        );
      }
      &:nth-child(4) {
        background: linear-gradient(
          360deg,
          rgba(255, 255, 255, 0.5) 44.59%,
          rgba(254, 165, 87, 0.5) 100%
        );
        margin-right: 0;
      }

      p:nth-child(1) {
        margin-bottom: 8px;
        font-weight: 600;
        font-size: 24px;
        line-height: 38px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(2) {
        line-height: 26px;
        height: 78px;
        font-size: 16px;
        margin-bottom: 24px;
        color: var(--kd-color-text-primary, rgb(13 13 13 / 90%));
      }
      p:nth-child(3) {
        img {
          width: 218px;
          height: 144px;
        }
      }
    }
  }

  @include responsiveV2($width-m) {
    ul {
      width: 732px;
      padding: 0 72px;
      box-sizing: border-box;
      text-align: center;
      li {
        &:nth-child(2n) {
          margin-right: 0 !important;
        }
      }
    }
  }
}
</style>
